import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FilterForm from "./components/FilterForm";
import RenderedItemsList from "./components/RenderedItemsList";
import * as api from './service/api';
import * as router from './service/routing';
import _ from 'lodash';
import LoadMoreButton from "./components/LoadMoreButton";

class ListView extends Component {

    static propTypes = {
        detailViewUrl: PropTypes.string,
        initialLimit: PropTypes.number,
        EXTKEY: PropTypes.string
    };

    initialState = {
        filter: {
            search: '',
            date: new Date(),
            categories: null,
            additionalCategories: null,
            limit: this.props.initialLimit,
        },
        renderedItems: [],
        total: null,
        isLoading: false,
        moreDataAvailable: true,
        options: {
            categories: [],
            additionalCategories: []
        }
    };

    constructor(props) {
        super(props);

        this.state = this.initialState;
        this.throttledFetchEvent = _.debounce(() => this.fetchEvents(this.state.filter), 1000, { 'leading': true });
    }


    componentDidMount() {
       this.fetchOptions(api.fetchCategories, 'categories', () => {
           this.fetchOptions(api.fetchAdditionalCategories, 'additionalCategories', () => {
               const filterParams = router.getFilterFromQueryParams(Object.keys(this.initialState.filter), this.state.options);
               this.setState({filter: {...this.state.filter, ...filterParams}}, () => {
                   this.fetchEvents(this.state.filter)
               });
           });
       });
    }

    handleInputChange = (newValue, selectId) => {
        this.setState(
            { filter: {...this.state.filter, [selectId]: newValue}},
            () => {
                this.throttledFetchEvent();
                router.updateFilterUrl(this.state.filter);
            }
        );
        return newValue;
    };

    resetFilterForm = () => {
        this.setState({filter: this.initialState.filter}, () => {
            this.fetchEvents(this.state.filter);
            router.updateFilterUrl(this.state.filter);
        });
    };

    loadMore = () => {
        this.setState(
            {
                isLoading : true,
                filter: {
                    ...this.state.filter,
                    limit: parseInt(this.state.filter.limit, 10) + parseInt(this.props.initialLimit, 10),
                }
            },
            () => {
                this.throttledFetchEvent();
                router.updateFilterUrl(this.state.filter);
            }
        );
    };

    fetchEvents = (filter) => {
        this.setState({isLoading: true});
        api.fetchEvents(filter).then(
            (response) => {
                this.setState(
                    {
                        renderedItems: response.data.events,
                        moreDataAvailable: parseInt(response.data.total, 10) > parseInt(this.state.filter.limit, 10),
                        total: response.data.total
                    },
                    () =>  this.setState(
                        {isLoading: false}
                    )
                )
            },
            (error) => {
                console.error(error.message);
                this.setState({isLoading: false});
            }
        );
    };

    fetchOptions = (apiCall, key, callback) => {
        apiCall().then(response => {
            this.setState(
                {options: {...this.state.options, [key]: response.data.map(item => ({label: item.name, value: item.uid}))}},
                callback()
            );
        });
    };

    render() {
        const {filter, isLoading, moreDataAvailable, options, total, renderedItems} = this.state;
        const {detailViewUrl, EXTKEY} = this.props;

        return (
            <div className={EXTKEY + "__wrapper--list"}>
                <FilterForm handleInputChange={this.handleInputChange} resetFilterForm={this.resetFilterForm} filter={filter} {...options} total={total} renderedItems={renderedItems} EXTKEY={EXTKEY} />
                <RenderedItemsList renderedItems={renderedItems} detailViewUrl={detailViewUrl} EXTKEY={EXTKEY} />
                {moreDataAvailable ? <LoadMoreButton handleLoadMoreClick={this.loadMore} isLoading={isLoading} EXTKEY={EXTKEY}/> : ''}
            </div>
        );
    }
}

export default ListView;



// WEBPACK FOOTER //
// ./React/src/ListView.js